import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React from "react";
import Head from "next/head";
import { GetServerSideProps } from "next";
import MarkdownContent from "@/containers/policy/MarkDownContent";
import { fetchCmsEduArticleBySlug } from "@/service/cms.service";

export default function Policy({ post = { content: "", title: "" } }) {
	return (
		<>
			<Head>
				<title>{post.title}</title>
			</Head>

			<div className="mx-auto flex h-full w-full max-w-screen-sm flex-col">
				<div className="flex-1 overflow-y-auto px-4 pt-8">
					<MarkdownContent childrenStr={post.content} />
				</div>
			</div>
		</>
	);
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const { locale } = context;

	try {
		const res = await fetchCmsEduArticleBySlug("privacyPolicy", locale || "en");
		if (!res) throw new Error("No article found");
		return {
			props: {
				post: { ...res },
				...(await serverSideTranslations(locale || "en", ["policy"])),
			},
		};
	} catch (error) {
		return {
			notFound: true,
		};
	}
};
